<script setup lang="ts">
    import { computed, ref } from 'vue'
    import { ErrorData, getViolationsFeedback } from '@/js/utils'

    const emit = defineEmits(['update:modelValue'])

    const suggestion = ref<string>('')

    export interface Props {
        modelValue: string[]
        suggestions?: string[]
        label?: string
        hint?: string
        toolTip?: string
        placeholder?: string
        dataTest?: string
        error?: ErrorData
        violationFields?: string[]
        isLoading?: boolean
        disabled?: boolean
    }

    const props = withDefaults(defineProps<Props>(), {
        label: '',
        hint: '',
        toolTip: '',
        placeholder: '',
        violationFields: () => [] as string[],
        suggestions: () => [] as string[],
        dataTest: '',
        error: () => {
            return {} as ErrorData
        },
        isLoading: false,
        disabled: false
    })

    const value = computed({
        get: () => props.modelValue,
        set: (val) => emit('update:modelValue', val)
    })
    const errorMessages = computed(() => {
        return props.error ? getViolationsFeedback(props.violationFields, props.error) : ''
    })
</script>

<template>
    <v-combobox
        v-model="value"
        :items="suggestions"
        chips
        closable-chips
        variant="outlined"
        multiple
        rounded="0"
        small-chips
        class="text-primary"
        :label="label"
        :hint="hint"
        :persistent-hint="!!hint"
        :hide-details="!hint && !errorMessages?.length"
        :error-messages="errorMessages"
        :error="!!errorMessages?.length"
        :data-test="dataTest"
        :placeholder="placeholder"
        :loading="isLoading"
        :hide-no-data="!suggestion"
        counter
    >
        <template #append-inner>
            <v-tooltip v-if="toolTip" location="top" :text="toolTip">
                <template #activator="{ props }">
                    <v-icon
                        v-bind="props"
                        icon="mdi-information-outline"
                        class="ml-2 text-primary"
                    />
                </template>
            </v-tooltip>
        </template>
    </v-combobox>
</template>

<style scoped></style>
